export default {
  GET_MACHINES_BUILDER_METADATA_REQUEST: 'GET_MACHINES_BUILDER_METADATA_REQUEST',
  GET_MACHINES_BUILDER_METADATA_SUCCESS: 'GET_MACHINES_BUILDER_METADATA_SUCCESS',
  GET_MACHINES_BUILDER_METADATA_FAILURE: 'GET_MACHINES_BUILDER_METADATA_FAILURE',

  CREATE_MACHINES_BUILDER_REQUEST: 'CREATE_MACHINES_BUILDER_REQUEST',
  CREATE_MACHINES_BUILDER_SUCCESS: 'CREATE_MACHINES_BUILDER_SUCCESS',
  CREATE_MACHINES_BUILDER_FAILURE: 'CREATE_MACHINES_BUILDER_FAILURE'
};
